import React, { useEffect, useRef } from "react"
import { useStore } from "@/store"
import { DOT_SIZE, getCurrentTimeRangeState, useCurrentTime } from "./_utils"

type CurrentTimeDotLayerProps = {
  startHour: number
  endHour: number
  mainCanvasRef: React.RefObject<HTMLDivElement>
}

const CurrentTimeDotLayer: React.FC<CurrentTimeDotLayerProps> = ({ startHour, endHour, mainCanvasRef }) => {
  const { calendarDimensions } = useStore()
  const currentTime = useCurrentTime()
  const dotRef = useRef<HTMLDivElement>(null)
  const { hourDiff, inRange } = getCurrentTimeRangeState(currentTime, startHour, endHour)

  useEffect(() => {
    const canvas = mainCanvasRef.current
    const dot = dotRef.current
    if (!canvas || !dot) return

    const onScroll = () => {
      dot.style.top = `${-canvas.scrollTop}px`
    }

    onScroll()
    canvas.addEventListener("scroll", onScroll)
    return () => canvas.removeEventListener("scroll", onScroll)
  }, [mainCanvasRef])

  const currentTimeTop =
    calendarDimensions.timeline.padding +
    calendarDimensions.timeline.offset / 2 +
    hourDiff * calendarDimensions.timeline.offset +
    (currentTime.minute / 60) * calendarDimensions.timeline.offset

  if (!inRange) {
    return null
  }

  return (
    <div
      className="absolute touch-none pointer-events-none overflow-hidden z-10"
      style={{
        top: calendarDimensions.timelineContainer.top,
        left: calendarDimensions.timeline.columnWidth - Math.ceil(DOT_SIZE / 2),
        width: DOT_SIZE,
        height: calendarDimensions.timelineContainer.height,
      }}
      data-testid="current-time-dot-layer"
    >
      <div ref={dotRef} className="absolute left-0" style={{ top: 0, width: DOT_SIZE }}>
        <div
          className="absolute rounded-full bg-[#888c8d]"
          style={{
            width: DOT_SIZE,
            height: DOT_SIZE,
            top: currentTimeTop - Math.floor(DOT_SIZE / 2),
          }}
          data-testid="current-time-dot"
        />
      </div>
    </div>
  )
}

export default CurrentTimeDotLayer
